const $$splitComponentImporter = () => import('/home/runner/work/vision-lab-frontend/vision-lab-frontend/src/routes/_auth/login.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { invitationTokenSchema } from '@/features/invitations/types/organizationInvitation';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
const loginSearchSchema = z.object({
  invitationToken: invitationTokenSchema.optional().catch(undefined)
});
export const Route = createFileRoute('/_auth/login')({
  validateSearch: loginSearchSchema,
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});